{
  "common": {
    "close": "Close",
    "noRecordsFound": "No records found",
    "requiredField": "This field is required"
  },
  "header": {
    "languageLabel": "Language",
    "logoAlt": "ARPM logo"
  },
  "toast": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning"
  },
  "create": {
    "heroEyebrow": "Create Appointment",
    "heroTitle": "Appointment Registration Page",
    "heroSubtitle": "Choose a suitable date and time to create your appointment quickly.",
    "panelTitle": "Appointment Details",
    "panelSubtitle": "Please make the required selections",
    "organizationLabel": "Organization",
    "facilityLabel": "Facility",
    "departmentLabel": "Department",
    "doctorLabel": "Doctor",
    "organizationPlaceholder": "Select organization",
    "facilityPlaceholder": "Select facility",
    "departmentPlaceholder": "Select department",
    "doctorPlaceholder": "Select doctor",
    "calendarTitle": "Select date and time",
    "timeHeader": "Available times for {{date}}",
    "selectableTimes": "Available Slots",
    "noAvailableTimes": "No available time slots found.",
    "createButton": "Create Appointment",
    "toasts": {
      "missingCoreSelection": "Organization, facility, department, and doctor selection are required.",
      "missingAppointmentSelection": "Please complete the date, time, and doctor selection.",
      "unavailableTime": "The selected time is no longer available. Please choose another time.",
      "invalidDate": "Please select a valid date.",
      "invalidTime": "Please select a valid time.",
      "created": "Appointment created.",
      "createdFallback": "Appointment created successfully.",
      "createError": "An error occurred while creating the appointment."
    }
  },
  "preparation": {
    "heroEyebrow": "Appointment Registration",
    "heroTitle": "Appointment Registration Form",
    "heroSubtitle": "Complete your information fully and create your appointment quickly.",
    "metaStepByStep": "Step-by-Step Registration",
    "metaSecureData": "Secure Data",
    "panelTitle": "Your Information",
    "panelSubtitle": "Please complete all fields below",
    "personalInfoTitle": "Personal Information",
    "addressInfoTitle": "Address Information",
    "tcLabel": "Patient ID",
    "tcPlaceholder": "Enter patient ID",
    "tcRequired": "Patient ID is required",
    "tcInvalid": "Please check the accuracy of the information you entered.",
    "nameLabel": "First Name",
    "namePlaceholder": "Enter your first name",
    "lastNameLabel": "Last Name",
    "lastNamePlaceholder": "Enter your last name",
    "birthDateLabel": "Date of Birth",
    "birthDatePlaceholder": "DD/MM/YYYY",
    "genderLabel": "Gender",
    "male": "Male",
    "female": "Female",
    "phoneLabel": "Phone Number",
    "phonePlaceholder": "5xx xxx xx xx",
    "emailLabel": "Email",
    "emailPlaceholder": "example@email.com",
    "emailInvalid": "Enter a valid email address",
    "cityLabel": "City",
    "cityPlaceholder": "Select city",
    "districtLabel": "District",
    "districtPlaceholder": "Select district",
    "neighborhoodLabel": "Neighborhood",
    "neighborhoodPlaceholder": "Neighborhood",
    "streetLabel": "Street",
    "streetPlaceholder": "Street",
    "buildingNoLabel": "Building No",
    "buildingNoPlaceholder": "Building No",
    "apartmentNoLabel": "Apartment No",
    "apartmentNoPlaceholder": "Apartment No",
    "nextButton": "Next",
    "checklistTitle": "Preparation Checklist",
    "checklistSubtitle": "Required fields will be marked below as you complete them.",
    "checklistEmpty": "No required fields have been completed yet.",
    "fieldLabels": {
      "name": "First Name",
      "lastName": "Last Name",
      "tc": "Patient ID",
      "birthDate": "Date of Birth",
      "gender": "Gender",
      "phone": "Phone Number",
      "email": "Email",
      "city": "City",
      "district": "District",
      "neighborhood": "Neighborhood",
      "street": "Street",
      "buildingNo": "Building No",
      "apartmentNo": "Apartment No"
    },
    "invalidEmailLabel": "Email (invalid)",
    "invalidBirthDateLabel": "Date of Birth (invalid)"
  },
  "consent": {
    "title": "Consent Information",
    "examination": "The examination:",
    "paragraph1": "Together with our doctor's assistant, you decide which areas you would like to have examined.",
    "paragraph2": "We use an advanced system that can distinguish benign and malignant lesions with high medical accuracy. The results are reviewed by one of our dermatologists who specializes in tele-dermatology.",
    "singlePrice": "The cost of a skin cancer screening is €22.00.",
    "includedTitle": "This service includes:",
    "items": [
      "Intake with the doctor's assistant",
      "Skin cancer screening of a suspicious lesion",
      "Report and diagnosis by our dermatologist",
      "Information about protecting your skin"
    ],
    "multiplePrice": "The cost of multiple skin cancer screenings is €18.00 per mole.",
    "absenceTitle": "In case of absence, you will receive a no-show invoice. The following exceptions apply:",
    "cancellation48": "Cancellation 48 hours before the appointment: no charge.",
    "cancellation24": "Cancellation 24 hours before the appointment: €15.00 per examination.",
    "sameDay": "Cancellation on the day of the appointment or no-show: €23.50 per examination."
  },
  "success": {
    "title": "Thank you!",
    "subtitle": "Your submission has been received successfully.",
    "message1": "You will receive an SMS and an email using the contact details you provided.",
    "message2": "If you do not receive the email, please check your spam folder."
  },
  "departments": {
    "Cardiology": {
      "label": "Cardiology",
      "icon": "noun-cardiology-4072383"
    },
    "Nephrology": {
      "label": "Nephrology",
      "icon": "noun-nephrology-7030227"
    },
    "Urology": {
      "label": "Urology",
      "icon": "kidney"
    },
    "Pulmonology": {
      "label": "Pulmonology",
      "icon": "lung"
    },
    "Neurology": {
      "label": "Neurology",
      "icon": "noun-neurology-5594376"
    },
    "Gastroenterology": {
      "label": "Gastroenterology",
      "icon": "gastroentology"
    },
    "Endocrinology": {
      "label": "Endocrinology",
      "icon": "noun-endocrinology-7357860"
    },
    "Hematology": {
      "label": "Hematology",
      "icon": "noun-hematology-7795354"
    },
    "Rheumatology": {
      "label": "Rheumatology",
      "icon": "noun-rheumatology-8059647"
    },
    "Dermatology": {
      "label": "Dermatology",
      "icon": "noun-dermatology-6378674"
    },
    "Infectious Diseases": {
      "label": "Infectious Diseases",
      "icon": "noun-infectious-disease-7245345"
    },
    "Ophthalmology": {
      "label": "Ophthalmology",
      "icon": "noun-ophthalmology-7215358"
    },
    "Otolaryngology": {
      "label": "Otolaryngology",
      "icon": "noun-otolaryngology-4840300"
    },
    "Orthopedics": {
      "label": "Orthopedics",
      "icon": "noun-orthopedics-6516988"
    },
    "Psychiatry": {
      "label": "Psychiatry",
      "icon": "noun-psychology-6565274"
    },
    "Obstetrics Gynecology": {
      "label": "Obstetrics and Gynecology",
      "icon": "noun-obstetrics-and-gynecology-1191435"
    },
    "Oncology": {
      "label": "Oncology",
      "icon": "noun-oncology-2312680"
    },
    "Transplantation": {
      "label": "Transplantation",
      "icon": "noun-transplant-2526273"
    },
    "Home Care": {
      "label": "Home Care",
      "icon": "noun-home-care-7110960"
    }
  }
}
